import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="RPN, Creation of Posts and Roster Verification Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>RPN, Creation of Posts and Roster Verification Committee</h3>
                                <p className='caboutus c-lineheight2dot5'>This is to inform all that the Recruitment and Promotion Norms, Creation of Posts and Roster Verification Committee of the Institute is re-constituted with the following members, until further orders:</p>

                               
                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dean, Administration & Finance</p>
                                                
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Registrar*</p>
                                               
                                                
                                            </td>
                                            <td> Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Prof. Sasidhar Gumma</p>
                                                <p>Department of Chemical Engineering and Dean - Academic Affairs</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Deputy Registrar</p>
                                                <p>Finance & Accounts</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Deputy Registrar / Assistant Registrar</p>
                                                <p>Recruitment*</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Vamshi Seshasayan</p>
                                                <p>Technical Officer, Computer Centre</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Joint Registrar / Deputy Registrar</p>
                                                <p>Establishment*</p>
                                            </td>
                                            <td>Member Secretary</td>
                                        </tr>

                                                                                
                                    </tbody>

                                </Table>
                               <p className='caboutus c-lineheight2dot5'><small>*on Ex-Officio basis</small></p>

                                <p className='caboutus c-lineheight2dot5'> Invited members- Depending upon the nature of the Agenda , the committee may invite HoDs, Faculty experts, Admin Officers and/or Technical Officers/Staff members.</p>
                                <p className='caboutus c-lineheight2dot5'> Invited Experts- Depending on the nature of Agenda, external experts will be invited for suggestions.</p>
                                <p className='caboutus c-lineheight2dot5'> Further, the Liaison Officers representing the Scheduled Castes (SC), Scheduled Tribes (ST), Other Backward Classes (OBC) and Persons with Benchmark Disabilities (PwBD) categories will be part of the committee, as invitees whenever required.</p>


                                <p className=' fw-bold c-headline caboutus mt-3 mb-3'> Key Functions of the Committee:</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Examine, review and recommend matters relating to the Recruitment and Promotion Norms of Non-Teaching Staff, including eligibility criteria, mode of recruitment, promotions, Non-Functional Upgradation (NFU), Limited  Departmental Examination (LDE), Seniority, Cadre restructuring and resolution of anomalies arising out of the implementation of the norms.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Examine and recommend proposals for the creation, redistribution, upgradation, redesignation and abolition of posts strictly within the sanctioned strength approved by the Ministry and the Board of Governors, taking into account the Institute’s requirements, manpower planning and applicable rules and guidelines.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Examine and certify the correctness of the reservation rosters before the same are utilized for Recruitment and Promotion processes.</li>
                                    
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;